<div class="ox-datepicker-container">
    <!-- Info section - displayed date, label and calendar icon-->
    <div class="ox-datepicker-info" [ngClass]="{ active: isDatePickerOpened }">
        <svg class="calendar-icon">
            <use xlink:href="#calendar"></use>
        </svg>
        <div>
            <label [attr.for]="dateType" [innerHtml]="label" data-crlat="datePickerValue"></label><br />
            @if (date && date.value) {
                <span class="displayed-date corol-displayed-date" [innerHtml]="formatDate(date.value)" data-crlat="datePickerText"> </span>
            }
        </div>
    </div>

    <!-- Fallback to simple input field if native date picker is not available -->
    @if (date && date.value) {
        @if (!isDateSupports) {
            <input
                class="ox-datepicker-fallback"
                type="text"
                [placeholder]="'dd/MM/yyyy'"
                [attr.id]="dateType"
                [value]="formatDate(date.value)"
                (blur)="onChange($event.target.value)" />
        } @else {
            <!-- Native Date Picker -->
            <input
                class="ox-datepicker"
                type="date"
                [min]="minDate"
                [max]="maxDate"
                [value]="formatDate(date.value, 'yyyy-MM-dd')"
                [attr.id]="dateType"
                (change)="onChange($event.target.value)"
                (click)="setActive()"
                (blur)="setInactive()" />
        }
    }
</div>
